
import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-hotel-line',
      title: 'Giặt đồ khách sạn / resort',
      description: 'Ga, khăn, áo choàng, rèm, đồng phục',
      time: '24h',
      note: 'Ký hợp đồng theo kg',
      color: 'blue',
      image: 'https://public.readdy.ai/ai/img_res/495dbe59757043027d3727936dee802a.jpg'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Giặt chăn – mền – drap',
      description: 'Giặt nước nóng, sấy khô, gấp gọn',
      time: '24h',
      note: 'Giảm giá 10.000đ/kg',
      color: 'teal',
      image: 'https://readdy.ai/api/search-image?query=Clean%20fresh%20blankets%2C%20comforters%2C%20bed%20sheets%20being%20processed%20in%20professional%20laundry%2C%20fluffy%20white%20bedding%2C%20home%20textiles%20washing%20service%2C%20cozy%20bedroom%20linens%2C%20family%20laundry%20service&width=400&height=300&seq=service-blanket-1&orientation=landscape'
    },
    {
      icon: 'ri-shirt-line',
      title: 'Giặt đồ dân sinh',
      description: 'Áo quần, đồ công sở, áo lạnh...',
      time: '24h',
      note: '15.000đ/kg',
      color: 'purple',
      image: 'https://readdy.ai/api/search-image?query=Clean%20pressed%20clothes%20hanging%20on%20hangers%2C%20business%20shirts%2C%20casual%20wear%2C%20winter%20jackets%2C%20everyday%20clothing%20items%20in%20professional%20laundry%20service%2C%20organized%20wardrobe%2C%20fresh%20clean%20garments&width=400&height=300&seq=service-clothes-1&orientation=landscape'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Giặt hấp – giặt khô',
      description: 'Vest, váy, áo dài, vải cao cấp',
      time: '48h',
      note: 'Giá theo món',
      color: 'amber',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20dry%20cleaning%20service%20with%20elegant%20suits%2C%20formal%20dresses%2C%20traditional%20Vietnamese%20ao%20dai%2C%20premium%20fabric%20garments%2C%20professional%20dry%20cleaning%20equipment%2C%20high-end%20clothing%20care&width=400&height=300&seq=service-drycleaning-1&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: 'Dịch vụ giao nhận tận nơi',
      description: 'Nhận – trả tại nhà',
      time: 'Theo lịch khách',
      note: 'Lấy đồ MIỄN PHÍ',
      color: 'green',
      image: 'https://readdy.ai/api/search-image?query=Delivery%20truck%20for%20laundry%20service%20in%20Da%20Lat%20mountain%20city%2C%20professional%20pickup%20and%20delivery%20service%2C%20clean%20van%20with%20laundry%20branding%2C%20home%20delivery%20service%2C%20mountain%20city%20landscape&width=400&height=300&seq=service-delivery-1&orientation=landscape'
    }
  ];

  const getColorClasses = (color: string) => {
    const colorMap = {
      blue: 'bg-blue-100 text-blue-600',
      teal: 'bg-teal-100 text-teal-600',
      purple: 'bg-purple-100 text-purple-600',
      amber: 'bg-amber-100 text-amber-600',
      green: 'bg-green-100 text-green-600'
    };
    return colorMap[color as keyof typeof colorMap] || 'bg-gray-100 text-gray-600';
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Dịch Vụ Giặt Ủi Chuyên Nghiệp
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Đa dạng dịch vụ giặt ủi phù hợp với mọi nhu cầu từ khách sạn đến hộ gia đình
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {services.slice(0, 4).map((service, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className={`w-12 h-12 ${getColorClasses(service.color)} rounded-full flex items-center justify-center mb-4`}>
                    <i className={`${service.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <div className="flex justify-between items-center text-sm">
                    <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700">
                      <i className="ri-time-line mr-1"></i>
                      {service.time}
                    </span>
                    <span className="text-teal-600 font-semibold">{service.note}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dịch vụ giao nhận đặc biệt */}
          <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl p-8 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-3xl"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4">Dịch vụ giao nhận tận nơi</h3>
                <p className="text-xl mb-6 text-green-100">
                  Nhận – trả tại nhà theo lịch khách hàng. Lấy miễn phí, giao chỉ từ 15.000/chuyến.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center bg-white/20 rounded-full px-4 py-2">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span>Phủ sóng toàn Đà Lạt</span>
                  </div>
                  <div className="flex items-center bg-white/20 rounded-full px-4 py-2">
                    <i className="ri-gift-line mr-2"></i>
                    <span>Miễn phí giao nhận</span>
                  </div>
                  <div className="flex items-center bg-white/20 rounded-full px-4 py-2">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>Đặt lịch linh hoạt</span>
                  </div>
                </div>
              </div>
              <div className="text-center lg:text-right">
                <img 
                  src={services[4].image}
                  alt="Dịch vụ giao nhận"
                  className="w-full max-w-md mx-auto lg:ml-auto h-64 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
